import Axios from 'axios';
import { ApplicationContext } from '../../../framework/framework/shared/ApplicationContext';
import { ProductService } from '../../../services/productService/ProductService';
import React = require('react');

export interface IHomeBaseProps {
    appCtx: ApplicationContext;
}

export interface IHomeBaseState {

}

export default class HomeBaseComponent<T extends IHomeBaseProps, S extends IHomeBaseState> extends React.Component<T, S> {
    axios = Axios;

    componentDidMount() {
        const dataUri = this.getUriHomeData();
        if (dataUri == null) { return; }
        const url = this.props.appCtx.buildUrl(dataUri);
        this.axios.get(url)
            .then(response => {
                this.onDataChanged(response.data);
            })
            .catch(error => { console.log(error); });
    }

    protected getUriHomeData() {
        return null;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected onDataChanged(_data: any) {

    }

    protected renderView() {
        return <></>;
    }

    render() {
        return this.renderView();
    }

    protected handleItemBuy(id: number, name: string): void {
        const productService = ProductService.Instance();
        productService.addToBasket(id, name, 1);
    }
}
